// extracted by mini-css-extract-plugin
module.exports = {"form":"CheckCouponForm_form__N2jse","textInput":"CheckCouponForm_textInput__12Y-j","fullPage":"CheckCouponForm_fullPage__2f-Z_"};